import { useMemo } from 'react';
import { APIType } from '~/backend/types';
import { Modality } from '~/domain/dicom/modality';
import type { ContourModelChoice } from '~/state/atoms/adaptiveReplanningAtoms';
import {
    compareLatestFirst,
    PredictionModel,
} from '~/utils/transforms/predictionModelsDataTransforms';
import { useBackendModels } from '../useBackend';

export function useComparisonContourModels(
    modality: Modality = Modality.CT
): PredictionModel[] {
    const { data: models } = useBackendModels(APIType.CONTOURING);
    return useMemo(
        () =>
            (models ?? [])
                .filter((model) => model.inputModalities.includes(modality))
                .sort(compareLatestFirst),
        [models, modality]
    );
}

// Found by name among every model: the choice was already made for the scan's modality.
export function useComparisonContourModel(
    choice: ContourModelChoice | undefined
): PredictionModel | undefined {
    const { data: models } = useBackendModels(APIType.CONTOURING);
    return choice
        ? models?.find((model) => model.name === choice.modelName)
        : undefined;
}
